import { Card, Space,Typography,theme } from "antd";

const { useToken } = theme;

const { Text } = Typography;

  const SectionCard: React.FC<{
    icon: React.ReactNode;
    title: React.ReactNode;
    extra?: React.ReactNode;
    children?: React.ReactNode;
  }> = ({ icon, title, extra, children }) => {

    const { token } = useToken();
    return(<Card
      style={{
        borderRadius: 16,
        border: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: '0 1px 0 rgba(60,64,67,.08)',
        marginBottom: 16,
      }}
      bodyStyle={{ padding: 20 }}
      title={
        <Space size={12}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 12,
              background: token.colorFillQuaternary,
              display: 'grid',
              placeItems: 'center',
            }}
          >
            {icon}
          </div>
          <Text strong>{title}</Text>
        </Space>
      }
      extra={extra}
    >
      {children}
    </Card>)
  }

    export default SectionCard;